// Vinci Wallet Elite Tiers.
// Bronze        : balance <  ₹1,00,000          → Foundation Tier
// Silver        : ₹1,00,000 ≤ b ≤ ₹10,00,000    → Trusted Counterparty
// Vinci Gold    : ₹10,00,001 ≤ b ≤ ₹25,00,000   → Executive Cap
// Vinci Platinum: balance >  ₹25,00,000         → Sovereign Cap
//
// Per Vinci Executive Command (Feb 11, 2026): every tier renders with
// the SAME Vinci Gold palette — the wallet liquid wave, hero glow,
// progress bar and every CTA button stay gold across all four tiers.
// The tier LABEL still shifts, marking the buyer's rank in the ecosystem.

const VINCI_GOLD_PALETTE = {
  palette: "Vinci Gold",
  primary: "#D8B23E",
  accent: "#F6E4A6",
  accentSoft: "#8A6A1A",
  bgFrom: "#1B1401",
  bgVia: "#050505",
  glow: "rgba(216,178,62,0.6)",
  ring: "rgba(216,178,62,0.45)",
  ledgerGlow: "rgba(216,178,62,0.45)",
};

export const WALLET_TIERS = {
  bronze: {
    key: "bronze", label: "Bronze",
    tagline: "Foundation Tier",
    threshold: 100000,
    ...VINCI_GOLD_PALETTE,
  },
  silver: {
    key: "silver", label: "Silver",
    tagline: "Trusted Counterparty",
    threshold: 1000000,
    ...VINCI_GOLD_PALETTE,
  },
  gold: {
    key: "gold", label: "Vinci Gold",
    tagline: "Executive Cap",
    threshold: 2500000,
    ...VINCI_GOLD_PALETTE,
  },
  platinum: {
    key: "platinum", label: "Vinci Platinum",
    tagline: "Sovereign Cap",
    threshold: Infinity,
    ...VINCI_GOLD_PALETTE,
  },
};

export function walletTier(balance) {
  const b = Number(balance || 0);
  if (b < 100000) return WALLET_TIERS.bronze;
  if (b <= 1000000) return WALLET_TIERS.silver;
  if (b <= 2500000) return WALLET_TIERS.gold;
  return WALLET_TIERS.platinum;
}

// Progress through the CURRENT tier band toward the next threshold.
export function tierProgress(balance) {
  const b = Math.max(0, Number(balance || 0));
  if (b < 100000) return b / 100000;                 // Bronze → Silver at ₹1L
  if (b <= 1000000) return (b - 100000) / 900000;    // Silver → Gold at ₹10L
  if (b <= 2500000) return (b - 1000000) / 1500000;  // Gold → Platinum at ₹25L
  return 1;                                          // Platinum — Sovereign cap
}
